import "./AutocompletePhoneNumber.css";

import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { Select } from "antd";
import { useEffect, useState } from "react";

import { getRequest } from "../../api/apiCaller";
import API_URL from "../../constant/api-url";

const AutocompletePhoneNumber = ({
  label = "Đầu số",
  value,
  onChange,
  switchboardGroup,
}) => {
  const [placeholder, setPlaceholder] = useState("Tất cả");
  const [listPhoneNumber, setListPhoneNumber] = useState([]);

  const getListPhoneNumber = async (business) => {
    if (!business) {
      const res = await getRequest(API_URL.CLOUD_PBX_NUMBER);
      setListPhoneNumber(res.data);
    } else {
      const res = await getRequest(API_URL.CLOUD_PBX_NUMBER_BUSINESS, {
        filter: {
          where: { business },
        },
      });
      setListPhoneNumber(
        res.data[0]?.numbers?.map((phone) => ({ id: phone })) || []
      );
    }
  };
  const handleFocus = () => {
    setPlaceholder("");
  };

  const handleBlur = () => {
    setPlaceholder("Tất cả");
  };

  useEffect(() => {
    const business = switchboardGroup === "all" ? null : switchboardGroup;
    getListPhoneNumber(business);
  }, [switchboardGroup]);

  return (
    <div className="autocomplete-list-phone-number__container">
      <label className="autocomplete-list-phone-number__label">{label}</label>
      <Select
        className="autocomplete-list-phone-number__select"
        mode="multiple"
        size="large"
        placeholder={placeholder}
        maxTagCount={2}
        onFocus={handleFocus}
        onBlur={handleBlur}
        allowClear
        popupClassName="autocomplete-list-phone-number__dropdown"
        clearIcon={
          <IconButton className="autocomplete-list-phone-number__button-clear">
            <Close />
          </IconButton>
        }
        value={value}
        onChange={onChange}>
        {listPhoneNumber.map((item) => (
          <Select.Option value={item.id}>{item.id}</Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default AutocompletePhoneNumber;
